export default "__VITE_ASSET__Axca8kSA__"